import React from 'react';
import MypageScheduleEditContainer from 'containers/MypageScheduleEditContainer/MypageScheduleEditContainer';

export default function MypageScheduleEditPage() {
    return (
        <MypageScheduleEditContainer />
    )
}
